import { ADMIN_HIGH } from "./constants/bitwiseOperations";

export default {
    items: [
        /*{
      lang_key: 'dashboard',
      name: 'Dashboard',
      url:  '/dashboard',
      icon: 'icon-speedometer',
    },*/
        {
            lang_key: "map",
            name: "Map",
            url: "/map",
            icon: "icon-map",
        },

        {
            lang_key: "orders",
            name: "Orders",
            url: "/order-management",
            icon: "icon-bag",
        },
        {
            lang_key: "billing",
            name: "My charges",
            //url:  '/company-billings',
            url: "/company-charges",
            icon: "icon-wallet",
        },
        {
            lang_key: "categories",
            name: "Categories",
            url: "/categories-management",
            icon: "icon-list",
        },
        {
            lang_key: "branch_goods",
            name: "Branch Goods",
            url: "/goods-management/branch",
            icon: "icon-book-open",
        },
        {
            lang_key: "goods",
            name: "Goods",
            url: "/goods-management",
            icon: "icon-book-open",
        },
        {
            lang_key: "goods-types",
            name: "Goods-types",
            url: "/good-type-management",
            icon: "icon-book-open",
        },
        {
            lang_key: "eta",
            name: "Eta",
            url: "/eta",
            icon: "icon-book-open",
        },
        {
            lang_key: "tag",
            name: "tags",
            url: "/goods-tags",
            icon: "icon-tag text-secondary",
        },
        {
            lang_key: "attributes",
            name: "Features",
            url: "/properties-management",
            icon: "icon-tag",
        },
        {
            lang_key: "providers",
            name: "Drivers",
            url: "/provider-management",
            icon: "fa fa-motorcycle",
        },
        {
            lang_key: "providers_settings",
            name: "Habilidades",
            url: "/provider-settings",
            icon: "fa fa-clipboard text-secondary",
        },
        {
            lang_key: "admins",
            name: "Admins management",
            url: "/admins-management",
            icon: "icon-organization icons",
        },
        {
            lang_key: "clients",
            name: "Clients",
            url: "/clients-management",
            icon: "icon-people",
        },
        {
            lang_key: "company",
            name: "Settings",
            url: "/settings",
            icon: "fa fa-gears",
        },
       /*  {
            name: "Services Supplier (Alpha)",
            url: "/service-suppliers",
        },
        {
            name: "Fleets (Alpha)",
            url: "/fleets",
        }, */
        {
            lang_key: "section",
            name: "Section",
            url: "/sections",
            icon: "fa fa-print",
        },
        {
            lang_key: "reports",
            name: "Reports",
            url: "/reports",
            icon: "fa fa-print",
        },
        {
            lang_key: "api_partners",
            name: "API Partners",
            url: "/api-partners",
            icon: "fa fa-handshake-o",
            type: ADMIN_HIGH,
        },
        /*{
      lang_key: 'billing',
      name: 'Billing',
      url:  '/company-billing',
      icon: 'icon-wallet',
    },*/
    ],
};




// WEBPACK FOOTER //
// ./src/_navOwner_en.js